import { lazy } from 'react';

const OrganisationPurposeRoute = lazy(
  () => import('../components/steps/organisation-purpose-step/OrganisationPurpose'),
);

export default OrganisationPurposeRoute;
